module.exports = __webpack_public_path__ + "static/flags/TP-95f4a8d3424ec3bda012cad9c5220b6e.gif";